import { Row, Col, Form, Input, FormInstance, Select } from 'antd';
import TaskType from '../../../models/TaskType';
import { truncateStringEllipsis } from '../../../utils/functions';

/**
 * @component CreateTaskForm.tsx
 * @description CreateTaskForm component to create a task.
 * @return { Component }
 */
interface CreateTaskFormProps {
  form: FormInstance;
  taskTypeAll: TaskType[];
}
function CreateTaskForm(props: CreateTaskFormProps) {

  const { Option } = Select;

  const handleTaskTypeChange = (value: number) => {
    props.form.setFieldsValue({
      tipotareaId: value,
    })
  };

  return (
    <div className="org-task-form">
      <Row>
        <Col span={24}>
          <Form layout={'vertical'} form={props.form} name="TaskTypeForm">
            <Form.Item
              name={'titulo'}
              
              label="Nombre de la Tarea:"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingresar el nombre de la tarea',
                },
                {
                  whitespace: true,
                  message: 'Por favor ingresar el nombre de la tarea',
                },
              ]}
            >
              <Input required placeholder={'Ingresa un nombre para la tarea'} />
            </Form.Item>
            <Form.Item
                required={true}
                name={'tipotareaId'}
                label="Tipo de tarea:"
                rules={[
                  {
                    required: true,
                    message: 'Por favor seleccione el tipo de tarea.',
                  },
                ]}
              >
                <Select
                  placeholder="Ingresa un tipo de tarea"
                  optionFilterProp="children"
                  onChange={handleTaskTypeChange}
                > 
                  {props.taskTypeAll.map(
                    (item) =>
                      item && (
                        <Option value={item.id} key={item.id}>
                          {truncateStringEllipsis(item.tipotarea, 43)}
                        </Option>
                      )
                  )}
                </Select>
              </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default CreateTaskForm;
